import { useState, useEffect, useCallback } from "react";
import { AdminLayout } from "@/components/admin/AdminLayout";
import { useAuth } from "@/context/AuthContext";
import { Mail, Send, Eye, RefreshCw, CheckCircle2, XCircle, Clock } from "lucide-react";
import { toast } from "sonner";

const TEMPLATES = [
  {
    name: "Promo VIP",
    subject: "🔥 Acceso VIP por tiempo limitado",
    html: `<h1 style="color:#fff;font-size:24px;">Algo NUEVO te espera 💋</h1>
<p style="color:#ddd;font-size:15px;line-height:1.5;">Hola amor,</p>
<p style="color:#ddd;font-size:15px;line-height:1.5;">Tengo un regalo especial para ti: <strong>50% de descuento</strong> en mi VIP por las próximas 48 horas.</p>
<p><a href="https://jglinks.co" style="display:inline-block;background:linear-gradient(90deg,#ec4899,#a855f7);color:#fff;padding:12px 24px;border-radius:9999px;text-decoration:none;font-weight:bold;">Reclamar mi descuento →</a></p>`,
  },
  {
    name: "Nuevo contenido",
    subject: "📸 Subí algo nuevo solo para ti",
    html: `<h1 style="color:#fff;font-size:24px;">Tienes que ver esto 🔥</h1>
<p style="color:#ddd;font-size:15px;line-height:1.5;">Acabo de subir contenido nuevo y eres de las primeras personas en saberlo. ¿Listas(os) para verlo?</p>
<p><a href="https://jglinks.co" style="display:inline-block;background:#fff;color:#000;padding:12px 24px;border-radius:9999px;text-decoration:none;font-weight:bold;">Ver ahora →</a></p>`,
  },
  {
    name: "Bienvenida",
    subject: "💌 Bienvenida(o) a mi mundo privado",
    html: `<h1 style="color:#fff;font-size:24px;">¡Qué bueno tenerte aquí! 💕</h1>
<p style="color:#ddd;font-size:15px;line-height:1.5;">Te uniste a mi círculo más cercano. Aquí recibirás antes que nadie:</p>
<ul style="color:#ddd;font-size:15px;line-height:1.7;">
  <li>Avisos de contenido nuevo</li>
  <li>Descuentos exclusivos</li>
  <li>Mensajes privados solo para ti</li>
</ul>`,
  },
];

const AdminBoletin = () => {
  const { getAuthHeaders } = useAuth();
  const [creators, setCreators] = useState([]);
  const [campaigns, setCampaigns] = useState([]);
  const [status, setStatus] = useState(null);

  const [creatorFilter, setCreatorFilter] = useState("");
  const [subject, setSubject] = useState("");
  const [html, setHtml] = useState("");
  const [testEmail, setTestEmail] = useState("");
  const [sending, setSending] = useState(false);

  const load = useCallback(async () => {
    try {
      const [s, cr, ca] = await Promise.all([
        fetch(`/api/admin/email/status`, { headers: { ...getAuthHeaders() } }).then((r) => r.json()).catch(() => null),
        fetch(`/api/admin/creators`, { headers: { ...getAuthHeaders() } }).then((r) => r.json()).catch(() => ({ creators: [] })),
        fetch(`/api/admin/email/campaigns?limit=20`, { headers: { ...getAuthHeaders() } }).then((r) => r.json()).catch(() => ({ campaigns: [] })),
      ]);
      setStatus(s);
      setCreators((cr.creators || []).filter((x) => x.active !== false));
      setCampaigns(ca.campaigns || []);
    } catch (e) {
      // silent
    }
  }, [getAuthHeaders]);

  useEffect(() => {
    load();
  }, [load]);

  const send = async (mode) => {
    if (!subject.trim() || !html.trim()) {
      toast.error("Asunto y contenido son obligatorios");
      return;
    }
    if (mode === "test" && !testEmail.trim()) {
      toast.error("Pon un email de prueba");
      return;
    }
    if (mode === "blast") {
      if (
        !window.confirm(
          `¿Enviar boletín a TODOS los leads${creatorFilter ? ` de @${creatorFilter}` : ""}?\n\nNo se puede deshacer.`
        )
      )
        return;
    }
    setSending(true);
    try {
      const body = {
        subject,
        htmlContent: html,
      };
      if (creatorFilter) body.creatorUsername = creatorFilter;
      if (mode === "test") body.testEmail = testEmail;
      const r = await fetch(`/api/admin/email/blast`, {
        method: "POST",
        headers: { "Content-Type": "application/json", ...getAuthHeaders() },
        body: JSON.stringify(body),
      });
      const ct = r.headers.get("content-type") || "";
      if (!ct.includes("application/json")) {
        toast.error("Función no disponible aún. Haz Deploy.");
        return;
      }
      const d = await r.json();
      if (!r.ok) {
        toast.error(d.detail || "Error al enviar");
        return;
      }
      if (mode === "test") {
        toast.success(`✉️ Test enviado a ${testEmail}`);
      } else {
        toast.success(
          `📤 Enviados: ${d.sent}/${d.totalRecipients}` +
            (d.failed > 0 ? ` · ${d.failed} fallidos` : "")
        );
        if (d.sampleErrors?.length) {
          toast.message("Errores", { description: d.sampleErrors.slice(0, 3).join("\n"), duration: 8000 });
        }
        load();
      }
    } catch (e) {
      toast.error("Error de red");
    } finally {
      setSending(false);
    }
  };

  return (
    <AdminLayout>
      <div className="space-y-6">
        <div className="flex items-start justify-between flex-wrap gap-3">
          <div>
            <h1 className="text-2xl md:text-3xl font-bold text-white mb-1 flex items-center gap-2">
              <Mail className="w-7 h-7 text-pink-400" />
              Boletín por email
            </h1>
            <p className="text-white/60 text-sm">
              Envía emails masivos a tus leads vía Resend
              {status?.sender && (
                <>
                  {" "}
                  · desde <span className="font-mono">{status.sender}</span>
                </>
              )}
            </p>
          </div>
          {status?.configured && (
            <span className="text-[11px] bg-green-500/20 text-green-300 border border-green-500/30 px-2 py-1 rounded">
              ✓ Resend conectado
            </span>
          )}
        </div>

        <div className="grid lg:grid-cols-3 gap-6">
          {/* Editor */}
          <div className="lg:col-span-2 space-y-4">
            <div className="bg-white/5 border border-white/10 rounded-xl p-4 space-y-3">
              <div>
                <label className="text-xs text-white/60 block mb-1">Modelo (filtro)</label>
                <select
                  value={creatorFilter}
                  onChange={(e) => setCreatorFilter(e.target.value)}
                  data-testid="email-creator-filter"
                  className="w-full bg-black/30 border border-white/10 rounded-lg px-3 py-2 text-white text-sm outline-none focus:border-white/30"
                >
                  <option value="">Todos los leads (sin filtro)</option>
                  {creators.map((c) => (
                    <option key={c.username} value={c.username}>
                      @{c.username} — {c.name}
                    </option>
                  ))}
                </select>
              </div>
              <div>
                <label className="text-xs text-white/60 block mb-1">Asunto</label>
                <input
                  type="text"
                  value={subject}
                  onChange={(e) => setSubject(e.target.value)}
                  placeholder="Ej: 🔥 Acceso VIP 50% off por 48h"
                  data-testid="email-subject"
                  className="w-full bg-black/30 border border-white/10 rounded-lg px-3 py-2 text-white text-sm outline-none focus:border-white/30"
                />
              </div>
              <div>
                <label className="text-xs text-white/60 block mb-1">
                  Contenido HTML
                </label>
                <textarea
                  value={html}
                  onChange={(e) => setHtml(e.target.value)}
                  rows={12}
                  placeholder="Escribe HTML directo. Se le añade un wrapper bonito automáticamente."
                  data-testid="email-html"
                  className="w-full bg-black/30 border border-white/10 rounded-lg px-3 py-2 text-white text-xs font-mono outline-none focus:border-white/30 resize-y"
                />
                <p className="text-[10px] text-white/40 mt-1">
                  Usa &lt;h1&gt;, &lt;p&gt;, &lt;a&gt;, &lt;ul&gt; · estilos inline · El header/footer se generan solos.
                </p>
              </div>

              {/* Templates */}
              <div>
                <p className="text-xs text-white/60 mb-2">Plantillas rápidas:</p>
                <div className="flex flex-wrap gap-2">
                  {TEMPLATES.map((t) => (
                    <button
                      key={t.name}
                      onClick={() => {
                        setSubject(t.subject);
                        setHtml(t.html);
                      }}
                      data-testid={`email-template-${t.name}`}
                      className="px-3 py-1.5 bg-white/5 hover:bg-white/10 border border-white/10 text-white/80 hover:text-white text-xs rounded-lg"
                    >
                      {t.name}
                    </button>
                  ))}
                </div>
              </div>

              {/* Test + Send */}
              <div className="pt-3 border-t border-white/10 space-y-3">
                <div className="flex gap-2">
                  <input
                    type="email"
                    value={testEmail}
                    onChange={(e) => setTestEmail(e.target.value)}
                    placeholder="tu@email.com (preview)"
                    data-testid="email-test-input"
                    className="flex-1 bg-black/30 border border-white/10 rounded-lg px-3 py-2 text-white text-sm outline-none focus:border-white/30"
                  />
                  <button
                    onClick={() => send("test")}
                    disabled={sending}
                    data-testid="email-send-test"
                    className="px-4 py-2 bg-white/10 hover:bg-white/20 border border-white/10 text-white text-xs font-medium rounded-lg disabled:opacity-50 flex items-center gap-1.5"
                  >
                    <Eye className="w-3.5 h-3.5" />
                    Enviar test
                  </button>
                </div>
                <button
                  onClick={() => send("blast")}
                  disabled={sending}
                  data-testid="email-send-blast"
                  className="w-full py-3 bg-gradient-to-r from-pink-500 to-purple-500 text-white font-bold rounded-lg disabled:opacity-50 flex items-center justify-center gap-2"
                >
                  <Send className="w-4 h-4" />
                  {sending ? "Enviando..." : `Enviar boletín ${creatorFilter ? `(@${creatorFilter})` : "(todos)"}`}
                </button>
              </div>
            </div>
          </div>

          {/* History */}
          <div className="space-y-4">
            <div className="flex items-center justify-between">
              <h2 className="text-white font-bold text-sm">Historial</h2>
              <button onClick={load} className="p-1 text-white/50 hover:text-white">
                <RefreshCw className="w-3.5 h-3.5" />
              </button>
            </div>
            {campaigns.length === 0 ? (
              <p className="text-white/40 text-xs text-center py-8">
                Sin campañas enviadas todavía
              </p>
            ) : (
              <div className="space-y-2">
                {campaigns.map((c) => (
                  <div
                    key={c.id}
                    className="bg-white/5 border border-white/10 rounded-lg p-3 text-xs"
                  >
                    <p className="text-white font-medium truncate mb-1">{c.subject}</p>
                    <div className="flex items-center gap-2 text-[11px]">
                      <span className="text-green-400 inline-flex items-center gap-0.5">
                        <CheckCircle2 className="w-3 h-3" /> {c.sent}
                      </span>
                      {c.failed > 0 && (
                        <span className="text-red-400 inline-flex items-center gap-0.5">
                          <XCircle className="w-3 h-3" /> {c.failed}
                        </span>
                      )}
                      <span className="text-white/40 ml-auto inline-flex items-center gap-0.5">
                        <Clock className="w-3 h-3" />
                        {new Date(c.createdAt).toLocaleString("es-CO", {
                          day: "2-digit",
                          month: "short",
                          hour: "2-digit",
                          minute: "2-digit",
                        })}
                      </span>
                    </div>
                    {c.creatorUsername && (
                      <p className="text-white/40 text-[10px] mt-1">
                        @{c.creatorUsername}
                      </p>
                    )}
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </AdminLayout>
  );
};

export default AdminBoletin;
